// extracted by mini-css-extract-plugin
export default {"page-header":"page-header","pageHeader":"page-header","os-windows":"os-windows","osWindows":"os-windows","logo-header":"logo-header","logoHeader":"logo-header","logo":"logo"};